import { LocaleMessages } from '@intlify/core-base';
import { VueMessageType } from 'vue-i18n';

export const en: LocaleMessages<VueMessageType> = {
  message: {
    continue: 'Continue',
    email_address: 'Email address',
    name: 'Name',
    surname: 'Last name',
    birthday: 'Birthdate',
    phoneNumber: 'Phone Number',
    dd: 'GG',
    mm: 'MM',
    yyyy: 'YYYY',
    profilingPermission: 'Profiling policy',
    marketingPermission: 'Marketing policy',
    register: 'Register',
    password: 'Password',
    signin: 'Login',
    error: 'Sorry, something went wrong, please try again later.',
    forgot_password: 'Forgot your password?',
    not_register: 'Not Signed Up yet?',
    repeat_password: 'Repeat Password',
    sign_up_email_sent: 'You will receive an email to your mailbox {email} to confirm your account in a few minutes',
    confirmation_sign_up_success_message: 'Registration completed successfully',
    confirmation_sign_up_error_message: 'Verification code expired, couldn\'t confirm {email}',
    sign_in_title: 'Log in or register in the reserved area',
    sign_in_error: 'Please try again later.',
    sign_in_not_authorized_error: 'Invalid credentials',
    sign_in_user_not_found_error: 'Sorry, your credentials do not appear correct. If you have registered in the past, try logging in using social media.',
    sign_in_3_time_limit: 'We\'re sorry something went wrong. We ask you to contact assistance by writing to "area.riservata{\'@\'}alpitourworld.it" detailing the problem encountered',
    sign_in_try_later_error: 'Please try again later.',
    sign_in_user_not_confirmed_error: 'Check your email to complete the registration process',
    logout_success: 'You were logged out successfully',
    logout_error: 'Please try again later.',
    sign_up_error: 'Please try again later.',
    send_password: 'Send password',
    forgot_password_title: 'Password Recovery',
    forgot_password_info: 'To reset your password, enter your email and confirm. An email will be sent to you with instructions to complete the process',
    forgot_password_success: 'A link to reset your password has been sent to your mailbox',
    forgot_password_error: 'Please try again later.',
    forgot_password_try_social: 'Sorry, something went wrong. If you have registered in the past, try logging in using social media.',
    forgot_password_generic_error: 'Oops something went wrong: Please try again later',
    restore_password: 'Confirm',
    reset_password_title: 'Reset Password',
    reset_password_success: 'Your password was successfully reset',
    reset_password_error: 'Verification code expired, couldn\'t reset password.',
    reset_password_required: 'Reset password required.',
    confirm_password: 'Confirm',
    user_already_exists_error: 'You have already signed up with one of the following services: alpitour.it, edenviaggi.it, turisanda.it',
    date_format: '{year}-{month}-{day}',
    registration_title: 'Registration to MyAlpitourWorld',
    complete_federated_login_title: 'Complete your registration',
    invalid_password: 'Invalid password',
    password_policy_title: 'Must contain atleast:',
    password_policy_spaces: 'Must not start or end with spaces',
    password_policy_length: '8 characters',
    password_policy_lowercase: '1 lowercase character',
    password_policy_uppercase: '1 uppercase character',
    password_policy_number: '1 numeric character',
    password_policy_special: '1 special character',
    under_age: 'You must be of legal age',
    invalid_birthdate: 'Invalid birthdate',
    or_access_with: 'Or access with',
    sign_up_privacy_policy: 'Having read the <a class="underline" style="color:{color}" class="font-bold" target="_blank" href="{privacyUrl}">privacy policy</a>.',
    profiling_consent_description: `I agree to the treatment of my personal data
      to analyze the detail of purchases, (e.g. types of payment instruments,
      my responses to market research, purchase volume, travel destinations, etc.)
      and / or the behavior of navigation and use of the platform, the sites and the Application,
      in order to define a profile of my preferences, for statistical and / or commercial and marketing purposes.`,
    marketing_consent_description: `I agree to the processing of my personal data for sending,
      with automated tools (email; telephone without operator - e.g. sms, mms, push notifications)
      and non-automated (paper mail; telephone with operator), newsletters and communications
      promotions on Alpitour products and initiatives, including those aimed at running
      market research and participation in prize shows and events organized by Alpitour.`,
    read_more: 'Read more',
    hide: 'Hide',
    sign_in_privacy_terms: 'Read the <a class="underline" target="_blank" href="{privacyUrl}">privacy policy</a>&nbsp',
    sign_in_general_conditions: 'and <a class="underline" target="_blank" href="{generalConditionsUrl}">general conditions</a>',

    otp_page_title: 'Verify your account with OTP',
    select_otp_type: 'Select the authentication type',
    otp_send_mail: 'An email will be sent to',
    otp_send_phone: 'A text message will be sent to the number',
    insert_otp: 'Enter the code received via ',
    send_otp_error: 'Error occured sending the otp code! If the problem persists, please contact assistance: "area.riservata{\'@\'}alpitourworld.it"',
    confirm_otp_error: 'Error occured during otp confirmation! If the problem persists, please contact assistance: "area.riservata{\'@\'}alpitourworld.it"',
    otp_code: 'OTP Code',
    email: 'E-mail',
    phone: 'Phone',
    get_user_contacts: 'An error occurred while retrieving the contacts associated with your user account! If the problem persists, contact support: Area.riservata{\'@\'}alpitourworld.it',
    otp_duration: 'The code lasts 15 minutes',
    back_to_login: 'Back to login',
    unknown_contacts: 'If you don\'t recognize the suggested contacts, they may be from your trusted travel agency',
    otp_support: 'Are you having trouble recovering your account? Write to "area.riservata{\'@\'}alpitourworld.it" for assistance',
    send_again: 'Send again'
  }
};
